import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatFormFieldModule,
  MatInputModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatToolbarModule,
  MatButtonModule,
  MatSliderModule,
  MatSnackBarModule,
  MatTabsModule,
  MatSelectModule, } from '@angular/material';
import { CdkTableModule } from '@angular/cdk/table';

import { DashboardComponent } from '../dashboard/dashboard.component';
import { HeaderModule } from './header.module';
import { DialogModule } from './dialog.module';

import {LimitToRange} from '../directives/LimitToRange.directive';

const imports = [
  MatTableModule,
  CdkTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatFormFieldModule,
  MatInputModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatToolbarModule,
  MatButtonModule,
  MatSliderModule,
  MatSnackBarModule,
  FormsModule,
  CommonModule,
  HeaderModule,
  DialogModule,
  MatTabsModule,
  MatSelectModule,
];

const exps = [
  DashboardComponent,
];

const declarations = [
  DashboardComponent,
  LimitToRange,
];

@NgModule({
  imports: [...imports],
  exports: [...exps],
  declarations: [...declarations]
})
export class DashboardModule { }
